import { ToastContainer } from "../../components/Common";
import AdminWarrantyRegistration from "./page";

const AdminWarrantyRegistrationPageWrapper = () => {
    return (
        <>
            <div className="page-content">
                <AdminWarrantyRegistration />
            </div>
            <ToastContainer />
        </>
    );
};

export default AdminWarrantyRegistrationPageWrapper;